const getConfigGetApiKeyByEnv = (apiEnv: string) => {
  if (apiEnv.toLowerCase() === "prd") {
    return process.env.NEXT_PUBLIC_CONFIG_GET_PROD_KEY || "";
  }
  if (apiEnv.toLowerCase() === "stg") {
    return process.env.NEXT_PUBLIC_CONFIG_GET_STG_KEY || "";
  }
  return process.env.NEXT_PUBLIC_CONFIG_GET_DEV_KEY || "";
};

export const configGetConfig = (
  apiEnv: string,
  access_token: string,
  configName: string,
  version: string
) => {
  const envParam = apiEnv.toLowerCase();
  const apiKey = getConfigGetApiKeyByEnv(apiEnv);
  const apiUrl = `https://api.pps-${envParam}.autodesk.com/config/${configName}/${version}`;

  return {
    method: "get",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
    },
  };
};
